<template>
    <div id="calendar" class="calendar">
        <Confirmation v-if="showConfirmation" @resetBooking="
            showConfirmation = false;
        $store.commit('setSelectedBooking', '');
        selectedGuests = 0;
        currentGuestInfo = undefined;
        firstName = '';
        lastName = '';
        emailAddress = '';
        phoneNumber = '';
        notes = '';
        " :response="bookingResponse" />
        <div v-if="!showConfirmation" :class="{
            'date-not-chosen': $store.state.availableBookings.length === 0,
        }">
            <div>
                <h2>
                    <img src="@/assets/icons/date-selector.svg" alt="" />
                    <span>Select Date</span>
                </h2>
                <div class="holder">
                    <div class="ui">
                        <ArrowButton @click="changeMonth(-1)" />
                        <h3>{{ month }}</h3>
                        <ArrowButton next @click="changeMonth(1)" />
                    </div>
                    <div class="days">
                        <div>S</div>
                        <div>M</div>
                        <div>T</div>
                        <div>W</div>
                        <div>T</div>
                        <div>F</div>
                        <div>S</div>
                    </div>
                    <div class="month">
                        <Day v-for="day in content" :date="day.date" :day="day.day" :disabled="day.disabled" />
                    </div>
                </div>
            </div>
            <div v-show="$store.state.availableBookings.length !== 0" id="available-times">
                <transition name="fade" appear>
                    <div>
                        <h2>
                            <img src="@/assets/icons/clock-icon.svg" alt="" />
                            <span>Select Time</span>
                        </h2>
                        <AvailableTimes />
                    </div>
                </transition>
            </div>
            <div id="form" class="details" v-if="$store.state.selectedBooking !== ''" :class="{ 'show-errors': showErrors }">
                <transition name="fade" appear>
                    <div>
                        <h2>
                            <img src="@/assets/icons/person-icon.svg" alt="" />
                            <span>Enter Details</span>
                        </h2>
                        <div class="holder" style="min-width: 300px">
                            <table>
                                <tr>
                                    <td class="label-holder">
                                        <span class="label">*First Name</span>
                                    </td>
                                    <td>
                                        <input :class="firstName !== '' ? 'has-value' : 'has-error'" type="text" name="firstname" id="firstname" v-model="firstName" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label-holder">
                                        <span class="label">*Last Name</span>
                                    </td>
                                    <td>
                                        <input :class="lastName !== '' ? 'has-value' : 'has-error'" type="text" name="lastname" id="lastname" v-model="lastName" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label-holder">
                                        <span class="label">*Email Address</span>
                                    </td>
                                    <td>
                                        <input :class="[
                                            emailAddress !== '' ? 'has-value' : '',
                                            emailAddress !== '' && testEmail.test(emailAddress) ? '' : 'has-error',
                                        ]" type="email" name="email" id="email" v-model="emailAddress" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label-holder">
                                        <span class="label">Company</span>
                                    </td>
                                    <td>
                                        <input type="text" name="company" id="company" v-model="company" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label-holder">
                                        <span class="label">*Phone</span>
                                    </td>
                                    <td>
                                        <input :class="[
                                            phoneNumber !== '' && phoneNumber.replace(/\D/g, '').length < 10
                                                ? 'has-error'
                                                : '',
                                        ]" type="tel" name="phonenumber" id="phonenumber" v-model="phoneNumber" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label-holder">
                                        <span class="label">Account Number</span>
                                    </td>
                                    <td>
                                        <input type="text" name="account" id="account" v-model="account" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label-holder">
                                        <span class="label">Zip Code</span>
                                    </td>
                                    <td>
                                        <input type="text" name="zip-code" id="zip-code" v-model="zipcode" maxlength="9" />
                                    </td>
                                </tr>
                                <tr style="display: none">
                                    <td class="label-holder"><span class="label">TM</span></td>
                                    <td>
                                        <input disabled="text" name="tm" id="tm" :value="$store.state.client.tmId" />
                                    </td>
                                </tr>
                                <tr class="guests">
                                    <td class="label-holder">
                                        <span class="label">Additional Guest<sub>(Up to 3)</sub></span>
                                    </td>
                                    <td>
                                        <div class="guest-options">
                                            <GuestButton v-for="guest in 4" :key="guest" :text="String(guest - 1)" :class="{ selected: selectedGuests === guest - 1 }" @click="selectedGuests = guest - 1" />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div class="check-holder">
                                            <input type="checkbox" name="emailConsent" id="emailConsent" v-model="emailConsent" />
                                            <label for="emailConsent">I agree that Tennessee Titans may send me content, offers, and more. By clicking
                                                “Book Now”, I agree to Tennessee Titans'
                                                <a href="https://www.tennesseetitans.com/about-us/terms-of-use" target="_blank" rel="noopener noreferrer">Terms</a>
                                                and understand that personal information will be used as described in the
                                                Tennessee Titans'
                                                <a href="https://www.tennesseetitans.com/about-us/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div class="check-holder">
                                            <input type="checkbox" name="textConsent" id="textConsent" v-model="textConsent" />
                                            <label for="textConsent">
                                                By checking this box and clicking “Book Now, I consent to receive periodic
                                                automated text messages from Tennessee Titans, regarding products and services and
                                                for other promotional/marketing purposes at the phone number provided, and I agree
                                                to Tennessee Titans’
                                                <a href="https://www.tennesseetitans.com/about-us/terms-of-use" target="_blank" rel="noopener noreferrer">Terms</a>. Consent is not a condition of purchase. Reply HELP for help, STOP to end.
                                                Message frequency varies. Carrier message and data rates may apply.
                                                <a href="https://www.tennesseetitans.com/about-us/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                                                applies.</label>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <Button text="Add Guest Details" style="width: 100%" link="" @click="errorsInForm ? null : (showGuestsModal = true)" class="submit" :class="{ disabled: errorsInForm }" v-if="selectedGuests > 0" />
                            <Button v-else-if="!bookingProcessing" text="Book Now" style="width: 100%" link="" @click="submitAppointment" class="submit" :class="{ disabled: errorsInForm }" :disabled="bookingProcessing" />
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
    <GuestModal v-if="showGuestsModal" :numGuests="selectedGuests" :currentGuestInfo="currentGuestInfo" @addGuest="selectedGuests = selectedGuests + 1" @removeGuest="selectedGuests = selectedGuests - 1" @close="showGuestsModal = false" @done="setGuests" @submitAppointment="submitAppointment" />
</template>

<script>
    import axios from "axios";
    import { format, add } from "date-fns";
    import ArrowButton from "@/components/ArrowButton";
    import GuestButton from "@/components/GuestButton";
    import Button from "@/components/Button";
    import AvailableTimes from "@/components/AvailableTimes";
    import GuestModal from "@/components/GuestModal";
    import Day from "@/components/Day";
    import Confirmation from "@/components/Confirmation";
    export default {
        name: "Form",
        created() {
            const preloadSelection = this.$store.state.preloadSelection;
            if (preloadSelection && preloadSelection.datetime && !preloadSelection.booked) {
                const preloadDate = new Date(String(preloadSelection.datetime).replace(" ", "T"));
                this.now = isNaN(preloadDate.getTime()) ? new Date() : preloadDate;
            } else {
                this.now = new Date();
            }
            this.getFirstMonthWithAppointments();
        },
        data() {
            return {
                month: "",
                content: "",
                now: undefined,
                selectedGuests: 0,
                showGuestsModal: false,
                currentGuestInfo: undefined,
                showConfirmation: false,
                testEmail: /^.+@.+\..+$/,
                showErrors: false,
                firstName: this.$store.state.client.first,
                lastName: this.$store.state.client.last,
                emailAddress: this.$store.state.client.email,
                phoneNumber: "",
                notes: "",
                company: "",
                account: "",
                zipcode: "",
                emailConsent: "",
                textConsent: "",
                bookingResponse: {},
                bookingProcessing: false,
                limitRecursion: 0,
                preloadApplied: false,
            };
        },
        components: {
            Button,
            ArrowButton,
            Day,
            AvailableTimes,
            GuestButton,
            GuestModal,
            Confirmation,
        },
        computed: {
            selectedSchedule() {
                return this.$store.state.selectedSchedule;
            },
            errorsInForm() {
                let errors = [];

                this.emailConsent ? "" : errors.push("email-consent");
                this.textConsent ? "" : errors.push("text-consent");
                this.firstName !== "" ? "" : errors.push("first-name");
                this.lastName !== "" ? "" : errors.push("last-name");
                this.emailAddress !== "" && this.testEmail.test(this.emailAddress) ? "" : errors.push("email-address");
                this.phoneNumber !== "" ? "" : errors.push("phone-number");
                this.phoneNumber !== "" && this.phoneNumber.replace(/\D/g, "").length < 10 ? errors.push("phone-number") : "";
                return errors.length > 0;
            },
        },
        methods: {
            normalizeDateTime(dateValue) {
                return String(dateValue || "")
                    .trim()
                    .replace("T", " ")
                    .replace(/\.\d+$/, "")
                    .slice(0, 16);
            },
            isBookingUnavailable(booking) {
                const classes = Array.isArray(booking?.classes) ? booking.classes : [];
                return classes.includes("booked") || classes.includes("disabled") || classes.includes("too-soon");
            },
            clearPreloadSelection() {
                this.$store.commit("setPreloadSelection", null);
            },
            applyPreloadedPosition() {
                if (this.preloadApplied) {
                    return;
                }

                const preload = this.$store.state.preloadSelection;
                if (!preload || !preload.group || !preload.slot) {
                    this.preloadApplied = true;
                    return;
                }

                if (preload.booked || !preload.datetime) {
                    alert("That requested time is no longer available. Please choose another appointment.");
                    this.preloadApplied = true;
                    this.clearPreloadSelection();
                    return;
                }

                const targetDate = String(preload.date || "").trim() || String(preload.datetime).slice(0, 10);
                if (targetDate === "") {
                    this.preloadApplied = true;
                    this.clearPreloadSelection();
                    return;
                }
                const targetCalendarDate = targetDate.replace(/-/g, "");

                const targetMonthKey = String(targetDate).slice(0, 7);
                const currentMonthKey = format(this.now, "yyyy-MM");

                if (targetMonthKey !== currentMonthKey) {
                    const targetMonth = new Date(`${targetDate}T00:00:00`);
                    if (!isNaN(targetMonth.getTime())) {
                        this.now = targetMonth;
                        this.getMonth();
                        return;
                    }

                    alert("That requested time is no longer available. Please choose another appointment.");
                    this.preloadApplied = true;
                    this.clearPreloadSelection();
                    return;
                }

                const targetDayLoaded = Array.isArray(this.content)
                    ? this.content.some((day) => String(day?.date || "") === targetCalendarDate)
                    : false;

                if (!targetDayLoaded) {
                    const targetMonth = new Date(`${targetDate}T00:00:00`);
                    if (!isNaN(targetMonth.getTime())) {
                        this.now = targetMonth;
                        this.getMonth();
                        return;
                    }
                }

                this.$store.commit("setSelectedDate", targetCalendarDate);
                const params = new URLSearchParams();
                params.append("date", targetCalendarDate);
                params.append("schedule", this.$store.state.selectedSchedule);
                axios
                    .post(`${this.$store.state.API}/Bookings.php`, params)
                    .then((response) => {
                        if (response.data.status !== "ok") {
                            alert("Unable to load the requested appointment slot.");
                            return;
                        }

                        const bookings = Array.isArray(response.data["json-content"]) ? response.data["json-content"] : [];
                        this.$store.commit("setAvailableBookings", bookings);

                        const requestedDateTime = this.normalizeDateTime(preload.datetime);
                        const matchingBooking = bookings.find(
                            (booking) =>
                                this.normalizeDateTime(booking.date) === requestedDateTime &&
                                !this.isBookingUnavailable(booking)
                        );

                        if (matchingBooking) {
                            this.$store.commit("setSelectedBooking", matchingBooking.date);
                            setTimeout(() => {
                                const element = document.querySelector("#form");
                                if (element) {
                                    element.scrollIntoView({ behavior: "smooth" });
                                }
                            }, 1);
                        } else {
                            alert("That requested time is no longer available. Please choose another appointment.");
                        }
                    })
                    .finally(() => {
                        this.preloadApplied = true;
                        this.clearPreloadSelection();
                    });
            },
            updateBookings() {
                this.$store.commit("setSelectedBooking", "");
                const params = new URLSearchParams();
                params.append("date", this.$store.state.selectedDate);
                params.append("schedule", this.$store.state.selectedSchedule);
                axios.post(`${this.$store.state.API}/Bookings.php`, params).then(this.onGetBookings);
            },
            onGetBookings(response) {
                if (response.data.status == "ok") {
                    this.$store.commit("setAvailableBookings", response.data["json-content"]);
                } else {
                    this.$store.commit("setSelectedDate", "");
                    alert("An error occurred getting the avilable times");
                }
            },
            submitAppointment() {
                if (this.bookingProcessing) {
                    console.log("booking processing");
                    return;
                }
                if (this.errorsInForm) {
                    this.showErrors = true;
                    return;
                }
                this.bookingProcessing = true;
                console.log("booking not processing");

                let combinedNotes = `${this.notes.trim()} Email Consent: ${this.emailConsent ? "Yes" : "No"} Text Consent: ${this.textConsent ? "Yes" : "No"
                    } Account Number: ${this.account.trim() === "" ? "-" : this.account.trim()} Zip Code: ${this.zipcode.slice(0, 9).trim() === "" ? "-" : this.zipcode.slice(0, 9).trim()}`;
                this.showGuestsModal = false;
                const params = new URLSearchParams();
                params.append("appointment", this.$store.state.selectedBooking);
                params.append("first", this.firstName.trim());
                params.append("last", this.lastName.trim());
                params.append("email", this.emailAddress.trim());
                params.append("phone", this.phoneNumber.trim().replace(/\D/g, ""));
                params.append("notes", combinedNotes.trim());
                params.append("company", this.company.trim());
                params.append("guests", this.selectedGuests);

                if (this.selectedGuests > 0) {
                    this.currentGuestInfo.forEach((element, id) => {
                        params.append(`guestDetails[${id}][first]`, element.first);
                        params.append(`guestDetails[${id}][last]`, element.last);
                        params.append(`guestDetails[${id}][email]`, element.email);
                        //guestDetails[0][first]: gf
                        //guestDetails[0][last]: gl
                        //guestDetails[0][email]: richard@channel1media.com
                    });
                }

                const $this = this;

                params.append("display", "");
                params.append("address", "");
                params.append("purl", this.$route.params.purl);
                params.append("schedule", this.$store.state.selectedSchedule);
                axios
                    .post(`${this.$store.state.API}/Appointment.php`, params)
                    .then(this.onSubmitAppointment)
                    .finally(() => {
                        $this.bookingProcessing = false;
                    });
            },
            onSubmitAppointment(response) {
                if (response.data.status == "ok") {
                    this.showConfirmation = true;
                    this.bookingResponse = response.data;
                } else {
                    this.$store.commit("setAvailableBookings", []);
                    alert(response.data.message ?? "An unknown error occured.");
                    this.updateBookings();
                }
            },
            setGuests(guests) {
                this.selectedGuests = guests.length;
                this.currentGuestInfo = guests;
            },
            changeMonth(months) {
                this.now = add(this.now, { months: months });
                this.getMonth();
            },
            getMonth() {
                const params = new URLSearchParams();
                params.append("month", format(this.now, "M"));
                params.append("year", format(this.now, "yyyy"));
                params.append("schedule", this.$store.state.selectedSchedule);
                axios.post(`${this.$store.state.API}/Calendar.php`, params).then(this.onGetCalendar);
            },
            getFirstMonthWithAppointments() {
                const params = new URLSearchParams();
                params.append("month", format(this.now, "M"));
                params.append("year", format(this.now, "yyyy"));
                params.append("schedule", this.$store.state.selectedSchedule);
                this.limitRecursion++;
                if (this.limitRecursion === 6) {
                    alert('No available appointments within 6 months');
                    return;
                }
                axios.post(`${this.$store.state.API}/Calendar.php`, params).then(this.onGetCalendarWithAppointments);
            },
            onGetCalendarWithAppointments(response) {
                if (response.data.status == "ok") {
                    const preload = this.$store.state.preloadSelection;
                    if (preload && !this.preloadApplied) {
                        this.month = response.data.month;
                        this.content = response.data["json-content"];
                        this.applyPreloadedPosition();
                        return;
                    }

                    let hasAvailableAppointments = response.data["json-content"].some(item => item.disabled === false);
                    if (hasAvailableAppointments) {
                        this.month = response.data.month;
                        this.content = response.data["json-content"];    
                        if (window.location.hash === '#calendar') {
                            setTimeout(() => {
                                document.querySelector('.month a:not(.disabled)')?.click();
                            }, 100);
                        }
                        this.applyPreloadedPosition();
                    } else {
                        this.now = add(this.now, { months: 1 });
                        this.getFirstMonthWithAppointments();
                    }
                } else {
                    alert("An error occurred getting the month");
                }
            },
            onGetCalendar(response) {
                if (response.data.status == "ok") {
                    this.month = response.data.month;
                    this.content = response.data["json-content"];
                    this.applyPreloadedPosition();
                } else {
                    alert("An error occurred getting the month");
                }
            },
        },
        watch: {
            selectedSchedule(newValue) {
                this.content = "";
                this.getFirstMonthWithAppointments();
            },
        },
    };
</script>

<style lang="scss" scoped>
    .check-holder {
        display: flex;
        gap: 10px;
        white-space: normal;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        input {
            accent-color: #4b92db;
            width: 20px;
        }

        a {
            font: inherit;
            color: inherit;
        }

        label {
            flex-grow: 1;
        }
    }

    .parking-holder {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .schedule-type {
        text-align: center;
        color: var(--white);
        font-weight: 600;
        margin-top: 75px;
        margin-bottom: 20px;
        font-size: 1.375rem;
        border: none;
    }

    p {
        text-align: center;
        color: var(--white);
        font-weight: 300;
        font-size: 1.125rem;
        max-width: 715px;
        margin: 0 auto;
        padding: 1rem;
    }

    .submit {
        position: relative;

        &:after {
            content: "fill in required fields to proceed";
            background: linear-gradient(180deg, #ab0808 0%, #f33 100%);
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: grid;
            place-items: center;
            font-weight: 600;
            color: var(--dark-red);
        }

        &.disabled {
            opacity: 0.3;
            border: 1px solid var(--accent);
            overflow: hidden;

            &:hover {
                opacity: 1;

                &:after {
                    opacity: 1;
                }
            }
        }
    }

    table {
        border-collapse: separate;
        border-spacing: 0 10px;
        table-layout: fixed;
    }

    table {
        color: var(--white);
        text-align: left;
        width: 100%;

        td {
            white-space: nowrap;
        }

        span {
            padding: 5px;
            padding-left: 0;
            font-size: 1rem;
            font-weight: 800;
            text-transform: uppercase;
        }

        .label-holder {
            width: 170px;

            sub {
                display: block;
            }
        }

        input {
            padding: 10px 15px;
            width: 100%;
            box-sizing: border-box;
            background: rgba(255, 255, 255, 0.08);
            border: none;
            color: #fff;
            font-family: "Neue Plak";
            font-weight: 800;
            font-size: 1rem;
        }

        .guests td {
            padding: 20px 0;
        }

        .guest-options {
            display: flex;
            gap: 5px;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 20px;

            button {
                height: 30px;
                width: 30px;
            }
        }
    }

    .invitation {
        font-weight: 400;
        font-size: 16px;
        line-height: 1.6;
        font-style: italic;
        margin-top: 25px;
    }

    .details {
        flex-grow: 1;

        &.show-errors .has-error {
            background: var(--dark-grey);
            border: 1px solid var(--accent);
            color: var(--white);
        }
    }

    .holder {
        padding: 20px 30px;
    }

    h2 {
        color: var(--white);
        padding: 20px 12px;
        margin: 0;
        font-size: 1.25rem;
        text-transform: uppercase;
        text-align: center;
        font-weight: 700;
        display: flex;
        align-items: center;
        gap: 10px;

        span {
            margin-bottom: 5px;
        }

        img {
            //vertical-align: middle;
        }
    }

    h3 {
        color: var(--white);
        font-size: 1rem;
        text-transform: uppercase;
        font-weight: 800;
    }

    .ui {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
    }

    #calendar {
        background: url("~@/assets/images/booking.jpg");
        background-size: cover;

        >div {
            overflow: hidden;
            max-width: 500px;
            margin: 25px auto;

            >div {
                margin-top: 75px;
                border-radius: 6px;
                background: linear-gradient(89.84deg,
                        rgba(217, 217, 217, 0.03) 0.15%,
                        rgba(217, 217, 217, 0.1) 51.51%,
                        rgba(217, 217, 217, 0.03) 99.89%);

                &:not(:nth-child(2)) {
                    background: linear-gradient(89.84deg,
                            rgba(217, 217, 217, 0.03) 0.15%,
                            rgba(217, 217, 217, 0.1) 51.51%,
                            rgba(217, 217, 217, 0.03) 99.89%);
                }

                h2 {
                    margin: 0 30px;
                }
            }

            @media (min-width: 1110px) {
                display: flex;
                gap: 5px;
                max-width: 1110px;
                margin: 75px auto;
                margin-top: 0;

                &.date-not-chosen {
                    display: block;
                    width: 450px;
                }

                &.confirmation {
                    margin-top: 75px;
                }

                >div {
                    position: relative;

                    &:after {
                        content: "";
                        height: 6px;
                        background: var(--accent);
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 0;
                        transition: width 0.2s ease-in-out;
                    }
                }
            }
        }
    }

    .days,
    .month {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        place-items: center;
        gap: 10px;
    }

    .month {
        grid-auto-rows: 40px;
    }

    .days {
        color: var(--white);
        padding: 10px 0;
        font-size: 0.75rem;
        font-weight: 800;
    }

    .month {
        padding: 15px 0;
    }
</style>
